// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3qb_C","fileBtn":"File_fileBtn__YYJ07","closeBtn":"File_closeBtn__1VZef","fileSelected":"File_fileSelected__1fa-o","disabled":"File_disabled__8FB-Y"};